// Voiturettes : le groupe du client bénéficie-t-il du tarif « membre » ? (réglage départs → groupes cochés)
const CART_MEMBER_GROUPS_DEFAULT = ['Membres', 'Abonnés', 'Académie', 'Joueurs Aio'];
const _normGrp = (g) => String(g || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
export const cartIsMemberRate = (settings, groupName) => {
  const groups = Array.isArray(settings?.cart_member_groups) && settings.cart_member_groups.length ? settings.cart_member_groups : CART_MEMBER_GROUPS_DEFAULT;
  return groups.map(_normGrp).includes(_normGrp(groupName));
};
// Tarif spécial nommé (ex. raison médicale) attribué au client
export const cartSpecialRate = (settings, clientId) => {
  if (!clientId) return null;
  const id = String(clientId);
  return (settings?.cart_special_rates || []).find(r => (r.client_ids || []).map(String).includes(id)) || null;
};
export const cartUnitPrice = (settings, groupName, clientId) => {
  // Portail : le backend renvoie directement le tarif effectif du client connecté
  if (clientId === undefined && settings?.my_cart_price !== undefined && settings?.my_cart_price !== null) return Number(settings.my_cart_price) || 0;
  const special = cartSpecialRate(settings, clientId);
  if (special) return Number(special.price) || 0;
  const member = cartIsMemberRate(settings, groupName);
  const v = member ? (settings?.cart_price_member ?? settings?.voiturette_price_member) : (settings?.cart_price_non_member ?? settings?.voiturette_price_non_member);
  return Number(v) || 0;
};
// Groupes autorisés à régler la voiturette à l'accueil (défaut : groupes au tarif membre)
export const cartOnSiteAllowed = (settings, groupName) => {
  const groups = Array.isArray(settings?.cart_on_site_groups) && settings.cart_on_site_groups.length ? settings.cart_on_site_groups : null;
  if (!groups) return cartIsMemberRate(settings, groupName);
  return groups.map(_normGrp).includes(_normGrp(groupName));
};
